<template>
    <section>
        <div class="row">
            <div class="col-12">
                <div class="field">
                    <label>คำค้นหา</label>
                    <input type="text" v-model="formFilter.keyword" class="input-field" placeholder="คำค้นหา" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6">
                <div class="field">
                    <label>วันที่ทำรายการ</label>
                    <div class="input-component-range">
                        <div class="input-component input-datepicker">
                            <datepicker input-class="input-field"
                                calendar-class="gadget-datepicker-box"
                                placeholder="จาก"
                                format="d/M/yyyy"
                                v-model="formFilter.createDateFrom">
                            </datepicker>
                            <b-icon icon="calendar2-minus"></b-icon>
                        </div>
                        <div class="input-component input-datepicker">
                            <datepicker input-class="input-field"
                                calendar-class="gadget-datepicker-box"
                                placeholder="ถึง"
                                format="d/M/yyyy"
                                v-model="formFilter.createDateTo">
                            </datepicker>
                            <b-icon icon="calendar2-minus"></b-icon>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                <div class="field">
                    <label>รายรับ</label>
                    <div class="input-range">
                        <input type="tel" v-model="formFilter.revenueFrom" class="input-field" placeholder="จาก" @keypress="$AppUtility.inputOnlyNumber($event)" />
                        <input type="tel" v-model="formFilter.revenueTo" class="input-field" placeholder="ถึง" @keypress="$AppUtility.inputOnlyNumber($event)" />
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                <div class="field">
                    <label>รายจ่าย</label>
                    <div class="input-range">
                        <input type="tel" v-model="formFilter.expenseFrom" class="input-field" placeholder="จาก" @keypress="$AppUtility.inputOnlyNumber($event)" />
                        <input type="tel" v-model="formFilter.expenseTo" class="input-field" placeholder="ถึง" @keypress="$AppUtility.inputOnlyNumber($event)" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="mt-3 text-center">
                    <button class="btn btn-secondary" @click="submitFilter()"><b-icon icon="search"></b-icon> ค้นหารายการ</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ModelAccountingFilter from '@/resources/models/AccountingFilter';

export default {
    data() {
        return {
            formFilter: ModelAccountingFilter.data()
        }
    },
    methods: {
        submitFilter() {
            this.$emit('lookup', this.formFilter);
        }
    }
}
</script>